export const PROVINCE_LEADING_ZEROS = 2; // based on regon with 9 digits
export const LEADING_ZEROS = 6; // based on regon with 9 digits
export const CONTROL_SUM_DEVIDER = 11;
